// Lib
import { ContentState, convertToRaw } from 'draft-js';
import { get } from 'lodash/fp';

// Utils
import { getNewTransactionId } from '../../utils/undoRedo/undoRedoTransactionManager';
import { getListChildNewLocation } from '../../../common/elements/utils/elementLocationUtils';

// Actions
import { createAndEditElement, updateElement } from '../actions/elementActions';
import { setLinkElementUrl } from '../link/linkActions';
import { setElementTypeAndUpdateElement } from '../../../common/elements/elementActions';
import { setSelectedElements } from '../selection/selectionActions';

// Constants
import { LINK_TYPE } from '../../../common/links/linkConstants';
import { TASK_LIST_TYPE } from '../../../common/taskLists/taskListConstants';
import { TASK_TYPE } from '../../../common/tasks/tasksConstants';

const updateTypeToLink = ({ id, elementType, data }, getState, dispatch) => {
    const transactionId = getNewTransactionId();

    const text = get(['temp', 'url'], data);
    const contentState = ContentState.createFromText(text);
    const rawState = convertToRaw(contentState);

    const undoChanges = { textContent: rawState, caption: null, showCaption: false, ignoreAutoType: true };

    dispatch(setElementTypeAndUpdateElement({ id, elementType, undoChanges, transactionId }));
    dispatch(updateElement({ id, changes: data, sync: false, transactionId: null }));
    dispatch(setLinkElementUrl({ id, url: data.temp.url, transactionId }));
};

const updateTypeToTask = ({ id, elementType, data }, getState, dispatch) => {
    const transactionId = getNewTransactionId();
    dispatch(
        setElementTypeAndUpdateElement({
            id,
            elementType: TASK_LIST_TYPE,
            transactionId,
        }),
    );
    dispatch(
        createAndEditElement({
            elementType: TASK_TYPE,
            location: getListChildNewLocation({ listId: id }),
            content: data.content,
            transactionId,
            select: false,
        }),
    );
    dispatch(setSelectedElements({ ids: [id], transactionId }));
};

export const updateElementType =
    ({ id, elementType, data }) =>
    (dispatch, getState) => {
        switch (elementType) {
            case LINK_TYPE:
                return updateTypeToLink({ id, elementType, data }, getState, dispatch);
            case TASK_TYPE:
                return updateTypeToTask({ id, elementType, data }, getState, dispatch);
            default:
                return dispatch(setElementTypeAndUpdateElement({ id, elementType, changes: data }));
        }
    };
